import { useState, useEffect } from 'react';
import './CollapsibleCard.scss';
import AngleDown from '../assets/angle-down.png';

const CollapsibleCard = ({ title, subtitle, children, noShadow = false, style = {}, onClick, disabled, isOpen: externalIsOpen }: { 
    title: any; 
    subtitle?: any, 
    children: any, 
    noShadow?: boolean, 
    style?: React.CSSProperties, 
    onClick?: () => void, 
    disabled?: boolean, //si está, deshabilita todas las opciones de una lista con excepción de la abierta
    isOpen?: boolean //si está, el estado de apertura se maneja desde afuera del componente. Si no está, se maneja internamente
}) => {

    const [internalIsOpen, setInternalIsOpen] = useState(false);

    useEffect(() => {
        if (externalIsOpen !== undefined) {
            setInternalIsOpen(externalIsOpen);
        }
    }, [externalIsOpen]);

    const isOpen = externalIsOpen !== undefined ? externalIsOpen : internalIsOpen;

    const cardStyle: React.CSSProperties = {
        boxShadow: noShadow ? '' : '0 4px 4px rgba(0,0,0,0.15)',
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
        ...style,
    };

    const handleHeaderClick = () => {
        if (!disabled) {
            if (externalIsOpen === undefined) {
                setInternalIsOpen(!internalIsOpen);
            }
            if (onClick) onClick();
        }
    };

    return (
        <div className="collapsible-card" style={cardStyle}>
            <div className='content-header' onClick={handleHeaderClick}>
                <div className="header">
                    <div className="title">{title}</div>
                    <div className="subtitle">{subtitle}</div>
                </div>
                <div>
                    <img src={AngleDown} alt="Angle" />
                </div>
            </div>
            {isOpen && <div className="content">{children}</div>}
        </div>
    );
};

export default CollapsibleCard;
